/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type ProductImportStatus = typeof ProductImportStatus[keyof typeof ProductImportStatus];


export const ProductImportStatus = {
  imported: 'imported',
  fused: 'fused',
  already_imported: 'already_imported',
  publication_imported_product_missing: 'publication_imported_product_missing',
  product_dropped: 'product_dropped',
  blocked: 'blocked',
  skipped: 'skipped',
  failed: 'failed',
  unknown_product: 'unknown_product',
} as const;
